import * as globals from '@wandb/common/css/globals.styles';
import {gold} from '@wandb/common/css/globals.styles';
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
  padding-right: 18px;
`;

export const Button = styled.button`
  background: Transparent;
  border: 1px solid ${gold};
  box-sizing: border-box;
  border-radius: 3px;
  color: ${globals.gold};
  cursor: pointer;
  width: fit-content;
  height: 30px;

  font-family: ${globals.fontName};
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 18px;
  text-align: center;
  white-space: nowrap;
`;
